function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { AppContext } from 'context';
import { useAction } from 'hooks';
import XIcon from 'svg/x.svg';
import Button from 'components/Form/Button';
import { CONSENT_MODAL } from 'modules/Mobile/constants';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import * as constants from '../../constants';
import messages from '../../messages';
import { ALLOW_COOKIES } from './constants';
import styles from './CookiesInfo.pcss';
const staticPolicyUrl = 'https://support.glucocontro.online/hc/en-us/articles/360012770119-Privacy-Policy';
const CookiesInfo = ()=>{
    useStyles(styles);
    const { cookies, isAlpineEnabled, staticStorageUrl } = useContext(AppContext);
    const isCookiesAllowed = cookies.get(ALLOW_COOKIES);
    const isMobileDisplayMode = useSelector(selectors.isMobileDisplayMode);
    const locale = useSelector(selectors.langCode);
    const openModal = useAction(actions.openModal, CONSENT_MODAL);
    const setStaticFilesDir = useAction(actions.setStaticFilesDir);
    const allowCookies = useAction(actions.setAllowCookies);
    const [showCookiesInfo, setShowCookiesInfo] = useState(!isCookiesAllowed);
    const policyUrlWithLocale = `${staticStorageUrl}/${constants.STATIC_FILES_SETTINGS.POLICY.DIR}/global/` + `${constants.STATIC_FILES_SETTINGS.POLICY.FILENAME_PATTERN}_${locale.toUpperCase()}.pdf`;
    const policyUrl = isAlpineEnabled === 'true' ? policyUrlWithLocale : staticPolicyUrl;
    const onCookiesAccept = ()=>{
        allowCookies();
        setShowCookiesInfo(false);
    };
    const onCloseCookiesWidget = ()=>{
        setShowCookiesInfo(false);
    };
    const onUrlClickHandler = (e, dir)=>{
        if (isAlpineEnabled === 'true') {
            setStaticFilesDir(dir);
            if (isMobileDisplayMode) {
                openModal();
                e.preventDefault();
            }
        }
    };
    const privacyLink = /*#__PURE__*/ _jsx("a", {
        target: "_blank",
        href: policyUrl,
        onClick: (evt)=>onUrlClickHandler(evt, constants.STATIC_FILES_SETTINGS.POLICY),
        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.links.privacyPolicy))
    });
    if (!showCookiesInfo) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.cookiesBox,
        "data-testid": "accept-cookies",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.cookiesBox__closeWrapper,
                onClick: onCloseCookiesWidget,
                children: /*#__PURE__*/ _jsx(XIcon, {
                    className: styles.cookiesBox__closeIcon
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: styles.cookiesBox__content,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.cookieInfo), {
                    values: {
                        privacyLink
                    }
                }))
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: messages.buttons.acceptAllCookies,
                className: "btn--block btn--filled",
                onClick: onCookiesAccept
            })
        ]
    });
};
export default CookiesInfo;
